import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { UserDataService } from '../../../shared/services/auth/userData.service';
import { PopupMessageComponent } from '../popup-message/popup-message.component';
import { NsideAssessService } from '../../../shared/services/assess.service';

@Component({
  selector: 'student-cases',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent,
    PopupMessageComponent
  ],
  templateUrl: './student-cases.component.html',
  styleUrl: './student-cases.component.css'
})
export class StudentCasesComponent implements OnInit {

  @Input() ssidNum: string = '';
  @Output() onClose = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<{student_identifier: string}>();

  studentCases: any[] = [];
  loading: boolean = false;
  currentBuildingId: string | null = null;
  messageModal: string | null = null;
  popupMessage: string | null = null;

  constructor(
    private nSideAssessService: NsideAssessService,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    this.loadCasesBySdid();
  }

  loadCasesBySdid(): void {
    this.loading = true;
    if (this.currentBuildingId) {
      this.nSideAssessService.findAssessCaseBySsid({building_id: this.currentBuildingId, student_identifier: this.ssidNum}).subscribe({
        next: (res) => {
          this.loading = false;
          this.studentCases = res.assess_cases;
        },
        error: (err) => {
          this.loading = false;
          console.error(err);
          this.messageModal = 'unsuccess'
          this.popupMessage = err.message;
        }
      });
    }
  }

  handleCloseStudentCases(): void {
    this.onClose.emit();
  }

  createNewAssessScreen(): void {
    if (this.ssidNum) {
      this.onSubmit.emit({student_identifier: this.ssidNum});
    }
  }

  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
  }
}
